import { render, staticRenderFns } from "./ConfigurePart.vue?vue&type=template&id=31d8a74e&scoped=true"
import script from "./ConfigurePart.vue?vue&type=script&lang=js"
export * from "./ConfigurePart.vue?vue&type=script&lang=js"
import style0 from "./ConfigurePart.vue?vue&type=style&index=0&id=31d8a74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8a74e",
  null
  
)

export default component.exports